module.exports = __webpack_public_path__ + "img/0090.f2c4d1bc.jpg";